import Moment from 'moment';

// // For some reason data fetched from backend has duplicated dataValues with same timestamps;
// // `cleanData` filters data from duplicated data items;
// const cleanData = (data) => {
//   let prevStart;
//   let prevStop;
//   const output = [];
//   for (let dataItem of data) {
//     if (!prevStart && !prevStop) {
//       output.push(dataItem);
//       prevStart = dataItem.start;
//       prevStop = dataItem.stop;
//       continue;
//     }
//     if (prevStart === dataItem.start && prevStop === dataItem.stop) {
//       continue;
//     }
//     output.push(dataItem);
//     prevStart = dataItem.start;
//     prevStop = dataItem.stop;
//   }
//   return output;
// };

const cleanData = data => {

  console.log('Data', data);
  return data;
}

// Creates points for highchart, based on data item received from backend;
// "rawSensorData" object is composed from min_t, max_t, min, max, samples;
// Where min_t / max_t - timestamp of minimum/maximum value of sensor;
//
// Each "rawSensorData" is aggregation of data values
//    of particular sensor between min_time - max_time;
const createPoints = function (rawSensorData) {
  // Highcharts consumes timestamps as unix timestamps in milliseconds
  const min_t = parseInt(Moment(rawSensorData.min_time).format('x'));
  const max_t = parseInt(Moment(rawSensorData.max_time).format('x'));

  const start = parseInt(Moment(rawSensorData.start).format('x'));
  const stop = parseInt(Moment(rawSensorData.stop).format('x'));

  const { min, max } = rawSensorData;
  // There are only one point
  if (min_t === max_t) {
    return [{ x: max_t, y: max }];
  }
  // If min_time, max_time are different, then we need to include both values (min / max)
  const diff = stop - start;
  return [
    { x: start + diff / 4, y: min },
    { x: stop - diff / 4, y: max },
  ];
};


export {
  cleanData,
  createPoints
}